import { render } from "./survey2.vue?vue&type=template&id=cefeec46&scoped=true"
import script from "./survey2.vue?vue&type=script&lang=js"
export * from "./survey2.vue?vue&type=script&lang=js"

import "./survey2.vue?vue&type=style&index=0&id=cefeec46&scoped=true&lang=css"

import exportComponent from "/home/gitlab-runner/builds/WwEazHb5/0/pln-pusdiklat/ups/assessment_hc_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cefeec46"]])

export default __exports__